import React from 'react';
import { FloaMin, Klarna, PaypalMin } from '@rakutenfrance/shared-svg';
import Box from '@mui/material/Box';
export const LabelTitle = (name) => {
    switch (name) {
        case 'KLARNA':
            return React.createElement(Klarna, { width: '32px', height: '32px' });
        case 'FLOA':
            return React.createElement(FloaMin, { width: '32px', height: '32px' });
        case 'PAYPAL':
            return (React.createElement(Box, { sx: {
                    height: '32px',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                } },
                React.createElement(PaypalMin, { width: '32px', height: '20px' })));
        default:
            return React.createElement(React.Fragment, null);
    }
};
